import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1be34854&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1be34854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be34854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be34854')) {
      api.createRecord('1be34854', component.options)
    } else {
      api.reload('1be34854', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=1be34854&scoped=true&", function () {
      api.rerender('1be34854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2q5D4uKCzKvVU/JS/comp/Voucher.vue"
export default component.exports